import { PriceMapper } from '@wix/bookings-uou-mappers';
var PriceDomain = /** @class */ (function () {
    function PriceDomain(servicePaymentDto, offeredAs, locale, regionalSettingsLocale, isUseIntlForPriceInBookFlowEnabled, formatter) {
        if (locale === void 0) { locale = 'en'; }
        if (regionalSettingsLocale === void 0) { regionalSettingsLocale = 'en'; }
        if (isUseIntlForPriceInBookFlowEnabled === void 0) { isUseIntlForPriceInBookFlowEnabled = false; }
        if (formatter === void 0) { formatter = function (key) { return key; }; }
        this.priceMapper = new PriceMapper({
            servicePaymentDto: servicePaymentDto,
            offeredAs: offeredAs,
            locale: locale,
            regionalSettingsLocale: regionalSettingsLocale,
            isUseIntlForPriceInBookFlowEnabled: isUseIntlForPriceInBookFlowEnabled,
            formatter: formatter,
        });
    }
    Object.defineProperty(PriceDomain.prototype, "text", {
        get: function () {
            return this.priceMapper.getText();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PriceDomain.prototype, "ariaLabel", {
        get: function () {
            return this.priceMapper.getAriaLabel();
        },
        enumerable: false,
        configurable: true
    });
    return PriceDomain;
}());
export { PriceDomain };
//# sourceMappingURL=price-domain.js.map